import type { Review } from '../../model/review/review';
import type { Product } from '../../model/product/product';

/**
 * Determines the best image to display for a testimonial card
 * Prioritizes review images over product images as fallback
 * @param review - Review object that may contain picture URLs
 * @param product - Product object that may contain product image URLs
 * @returns The image URL to display, or empty string if no images available
 */
export function getTestimonialDisplayImage(review: Review, product?: Product): string {
  const hasReviewImage = review.pictureUrls && review.pictureUrls.length > 0;

  if (hasReviewImage) {
    return review.pictureUrls[0];
  }

  if (product?.productImageUrls?.[0]) {
    return product.productImageUrls[0];
  }

  return '';
}

